import { render, staticRenderFns } from "./tiscCard.vue?vue&type=template&id=166df81f&"
import script from "./tiscCard.vue?vue&type=script&lang=js&"
export * from "./tiscCard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports